'use strict';

// Constructor
var FurtherHelp = function () {
    $('.block-block-content-further-help .inner').matchHeight();
    
    // Related content on inner pages
    $('.field--name-field-related-content-paragraph .inner .spf-article-body').matchHeight();
};

module.exports = FurtherHelp;
